import React, { useState } from "react";
import Modal from "../common/Modal";
import Input from "../common/Input";
import Button from "../common/Button";

const AddressModal = ({ isOpen, onClose, onSave, initialData }) => {
  const [addressData, setAddressData] = useState(initialData || {
    label: "",
    line1: "",
    line2: "",
    city: "",
    state: "",
    pinCode: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAddressData({ ...addressData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(addressData);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} closeModal={onClose} title="Address Details">
      <form onSubmit={handleSubmit}>
        <Input
          label="Address Label"
          name="label"
          value={addressData.label}
          onChange={handleChange}
          placeholder="Home, Office, etc."
        />
        <Input
          label="Line 1"
          name="line1"
          value={addressData.line1}
          onChange={handleChange}
          placeholder="Address Line 1"
          required
        />
        <Input
          label="Line 2"
          name="line2"
          value={addressData.line2}
          onChange={handleChange}
          placeholder="Address Line 2"
        />
        <Input
          label="City"
          name="city"
          value={addressData.city}
          onChange={handleChange}
          placeholder="Enter City"
          required
        />
        <Input
          label="State"
          name="state"
          value={addressData.state}
          onChange={handleChange}
          placeholder="Enter State"
          required
        />
        <Input
          label="Pin Code"
          name="pinCode"
          value={addressData.pinCode}
          onChange={handleChange}
          placeholder="Enter Pin Code"
          required
        />
        <div className="mt-4 flex justify-end space-x-2">
          <Button variant="primary" type="submit">
            Save Address
          </Button>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default AddressModal;
